import React from "react"
import Reveal from "react-reveal/Reveal"

import Tile from "./tile"
import LoadButton from "./loadButton"

import styles from "../styles/components/grid.module.scss"

class Grid extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      maxVisible: 12,
      initialVisible: 12,
      isMobile: true,
      loadAll: false,
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize = () => {
    if (window.innerWidth > 768 && this.state.isMobile) {
      this.setState({
        isMobile: false,
        maxVisible: 15,
        initialVisible: 15,
      })
    } else if (window.innerWidth <= 768 && !this.state.isMobile) {
      this.setState({
        isMobile: true,
        maxVisible: 12,
        initialVisible: 12,
      })
    }
  }

  loadMore = () => {
    this.setState(prevState => {
      const increment = prevState.isMobile ? 12 : 15
      return { maxVisible: prevState.maxVisible + increment }
    })
  }

  loadAll = () => {
    this.setState({ maxVisible: this.props.tiles.length, loadAll: true })
  }

  loadLess = () => {
    this.setState(prevState => {
      return { maxVisible: prevState.initialVisible, loadAll: false }
    })
  }

  render() {
    var button = null
    if (this.props.tiles.length <= this.state.initialVisible) {
      button = null
    } else if (this.props.tiles.length > this.state.maxVisible) {
      button = <LoadButton text="View All" onClick={this.loadAll} />
    } else if (this.state.maxVisible >= this.props.tiles.length) {
      button = <LoadButton text="View Less" onClick={this.loadLess} />
    }

    return (
      <div className={styles.container}>
        <div className={styles.header}>{this.props.header}</div>
        <div className={styles.gridContainer}>
          {this.props.tiles &&
            this.props.tiles.map((tile, i) => {
              if (i < this.state.maxVisible || this.state.loadAll) {
                return (
                  <Reveal
                    effect="flip90"
                    duration={350 + 100 * (i % this.state.isMobile ? 2 : 5)}
                    delay={100 * (i % this.state.isMobile ? 2 : 5)}
                    fraction={0.75}
                    // duration={350 + 100 * (i % 8)}
                    // delay={100 * (i % 8)}
                    key={i}
                  >
                    <Tile {...tile} fullGrid />
                  </Reveal>
                )
              } else return null
            })}
        </div>
        {button && <div className={styles.buttonContainer}>{button}</div>}
      </div>
    )
  }
}

export default Grid
